 const StatusConformidade = {
    NAO_FISCALIZADO: 1,
    CONFORME:  2,
    NAO_CONFORME: 3,
    INCONFORMIDADE_CORRIGIDA: 4
};
  
export default StatusConformidade;